import { Component, ElementRef, EventEmitter, Input, Optional, Output, Renderer2, Self, ViewChild, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { getRandomId } from 'src/app/shared/extensions/string.extensions';

@Component({
    selector: 'app-standard-slider',
    templateUrl: './standard-slider.component.html',
    styleUrls: ['./standard-slider.component.scss'],
    standalone: false,
})
export class StandardSliderComponent implements ControlValueAccessor {
    @Input() public label: string;
    @Input() public hint: string;
    @Input() public maxValue: number;
    @Input() public minValue: number;
    @Input() public step: number;
    @Input() public unit: string;
    @Input() public tooltipText: string;
    @Input() public disabled = false;
    @Input() public hideInputField = false;
    @Output() public sliderChanged = new EventEmitter<number>();

    @Self() @Optional() public controlDirective = inject(NgControl, {
        self: true,
        optional: true,
    });
    private renderer = inject(Renderer2);

    @ViewChild('bubble', { static: true }) private bubble: ElementRef;

    public id: string;
    public data: number;
    public visible = true;

    constructor() {
        if (this.controlDirective) {
            this.controlDirective.valueAccessor = this;
        }

        this.id = getRandomId();
    }

    public onChangeFn = (_: number) => {
        return;
    };

    public onTouchedFn = () => {
        return;
    };

    public writeValue(value: number): void {
        if (value != null) {
            this.data = value;
        } else {
            this.data = 0;
        }

        this.generateSliderBubble();
    }

    public registerOnChange(fn: () => void): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public onChange() {
        this.onChangeFn(this.data);
        this.generateSliderBubble();

        this.sliderChanged.emit(this.data);
    }

    private generateSliderBubble() {
        let value = this.data;
        const min = this.minValue ? this.minValue : 0;
        const max = this.maxValue ? this.maxValue : 100;

        if (value < min) {
            value = min;
        }

        if (value > max) {
            value = max;
        }

        const newValue = Number(((value - min) * 100) / (max - min));
        const bubble = this.bubble.nativeElement as HTMLOutputElement;
        bubble.innerHTML = value.toString();

        if (bubble.getAttribute('data-bubble') == null) {
            this.renderer.setAttribute(bubble, 'data-bubble', value.toString());
        }

        const newPosition = Math.ceil(5 - newValue * 0.15);
        const leftPosition = `calc(${newValue}% + ${newPosition}px)`;
        this.renderer.setStyle(bubble, 'left', leftPosition);
    }
}
